module.exports = __webpack_public_path__ + "static/media/icon_specs-wetting.ccf72d3b.svg";